<template>
    <div>
        <h1>Paid your reservations</h1>
        <div v-if="order" class="resume">
            <table width="100%">
                <thead>
                    <tr>
                        <td>Name</td>
                        <td>Quantity</td>
                        <td>Unit Price</td>
                        <td>Tax</td>
                        <td>Total</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in order.rows" :key="row.id">
                        <td>{{row.product.name}}</td>
                        <td>{{row.quantity}}</td>
                        <td>{{row.unitPrice}}</td>
                        <td>{{row.tax}}</td>
                        <td>{{row.price}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>&nbsp;</td> 
                        <td>&nbsp;</td> 
                        <td>&nbsp;</td>
                        <td>CHF {{order.taxTotal}}</td> 
                        <td>CHF {{order.total}}</td> 
                    </tr>
                </tfoot>
            </table>
            <div v-if="step==1">
                <h1>Billing information</h1>
                <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveBillingAddress)">
                        <div>
                            <div class="form-col">
                                <ValidationProvider rules="required" v-slot="{errors}">
                                    <input type="text" name="Adress" v-model="billingInfo.addressLine1" placeholder="Adress" />
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{errors}">
                                    <input type="text" name="Postal code" v-model="billingInfo.postalCode" placeholder="Postal Code" />
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{errors}">
                                    <input type="text" name="City" v-model="billingInfo.city" placeholder="City" />
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{errors}">
                                    <select v-model="billingInfo.country" placeholder="country" name="Country">
                                        <option v-for="country in countries" :key="country.id" :value="country.id">{{country.text}}</option>
                                    </select>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div>
                            <button class="btn" style="margin-right:30px" @click.prevent="$router.go(-1)">Return</button>
                            <button class="btn primary">Next</button>
                        </div>
                        
                    </form>
                </ValidationObserver>
            </div>
            <div v-if="step==2">
                <h1>Paid by credit card</h1>
                <div>
                    <customer-card v-model="cardId"/>
                </div>
                <div v-if="cardId">
                    <button class="btn" @click="submit()">Paid</button>
                </div>
            </div>
            <div v-if="step=='stepUp'">
                <iframe name="step-up-iframe" height="400" width="400" />
                <form id="step-up-form" ref="stepUpForm" target="step-up-iframe" method="POST" :action="acsUrl">
                    <input v-model="pareq" type="hidden" name="PaReq">
                    <input type="hidden" name="MD" :value="cardId+';'+authenticationTransactionId">
                    <input type="hidden" name="TermUrl" :value="apiHost+'billing/invoice/'+hash+'/check'">
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationProvider,ValidationObserver } from 'vee-validate';
import { API_URL } from "../../../config-local"
import { mapActions, mapGetters } from 'vuex'
import CustomerCard from '../../components/card/CustomerCard.vue'
import countryList from '../../utils/countries'

export default {
    components: {
        CustomerCard,
        ValidationProvider,
        ValidationObserver
    },
    data: () => ({
        cardId:null,
        billingInfo:{},
        step:1,
        loading:false,
        pareq: null,
        acsUrl: null,
        stepUp: false,
        authenticationTransactionId: null,
    }),
    computed:{
        ...mapGetters("scheduler",["order"]),
        countries () {
            return [...countryList]
        },
        hash(){
            return this.order.invoice.hash
        },
        apiHost(){
            return API_URL;
        }
    },
    mounted () {
        window.addEventListener('message', (event) => {
            if (event.origin === API_URL) {
                if (event.data !== undefined) {
                this.checkPayment(event.data)
                }
            } else {
                //console.log("message", event)
            }
        }, false)

        if(this.order.billingAddress){
            this.step=2;
        }
    },
    methods:{
        ...mapActions("order",["orderConfirmation"]),
        ...mapActions("invoice", ['setupPayment']),
        submit () {
            this.loading = true
            this.setupPayment({ hash: this.hash, cardId: this.cardId })
                .then((data) => {
                    if(data.status && data.status=='ok'){
                        this.successPayment()
                    }else{
                        this.acsUrl = data.acsUrl
                        this.pareq = data.pareq
                        this.authenticationTransactionId = data.authenticationTransactionId
                    }
                    
                })
                .finally(() => {
                    if (this.acsUrl && this.pareq) {
                        this.step = 'stepUp'
                        setTimeout(() => this.$refs.stepUpForm.submit(), 200)
                    }
                })
        },
        checkPayment (md) {
            this.checkPayout({
                MD: md,
                hash: this.hash
            })
            .then((data) => {
                if (data.status) {
                    if (data.status === 'retry') {
                        this.checkPayment(md)
                    } else if (data.status === 'error' || data.status === 'not found') {
                        console.log("Error")
                    } else if (data.status === 'already') {
                        console.log("Ready")
                    } else if(data.status === 'ok') {
                        this.successPayment()
                    }
                }
            })
        },
        successPayment () {
            this.orderConfirmation({orderId:this.order.id})
            .then(()=>{
                this.$router.push("/confirmdate")
            })
        },
        saveBillingAddress(){
            this.$store.dispatch("order/billingAddress",{
                orderId:this.order.id,
                address:this.billingInfo
            }).then(() => {
                this.step++
            }).catch((data) => {
                console.log(data);
            })
        }
    }
}
</script>

<style lang="less">

    h1{
      font-size: 24px;
      color: #2F2B2B;
      margin-bottom: 50px;
      font-weight: 800;
    }
    .resume{
        width: 100%;
        background-color: #F6F6F6;
        padding: 50px;
        table{
            margin-bottom: 40px;
            td{
                padding: 10px;
            }
            thead,tfoot{
                td{
                    font-weight: bold;
                }
            }
        }
    }

</style>